import { render, staticRenderFns } from "./ClientBusinessunitForm.vue?vue&type=template&id=3cbd4da6"
import script from "./ClientBusinessunitForm.vue?vue&type=script&lang=js"
export * from "./ClientBusinessunitForm.vue?vue&type=script&lang=js"
import style0 from "./ClientBusinessunitForm.vue?vue&type=style&index=0&id=3cbd4da6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cbd4da6')) {
      api.createRecord('3cbd4da6', component.options)
    } else {
      api.reload('3cbd4da6', component.options)
    }
    module.hot.accept("./ClientBusinessunitForm.vue?vue&type=template&id=3cbd4da6", function () {
      api.rerender('3cbd4da6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientForm/components/ClientBusinessunitForm.vue"
export default component.exports